import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import classNames from "classnames";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: "center",
    background: "transparent",
    color: "white",
    fontWeight: 500,
    position: "relative",
    fontFamily: "Gilroy-Medium, sans-serif",
    fontSize: "40px",
  },
  dot: {
    position: "absolute",
    right: 0,
    top: 0,
    fontSize: "36px",
  },
  paperTime: {
    fontSize: "16px",
    fontWeight: 500,
  },
}));

interface CountDownProps {
  countDownDate?: Date;
}

interface SplitDate {
  seconds: string;
  minutes: string;
  hours: string;
  days: string;
}

export default function CountDown(props: CountDownProps) {
  const classes = useStyles();

  const { countDownDate } = props;
  const [date, setDate] = useState<SplitDate>({
    seconds: "00",
    minutes: "00",
    hours: "00",
    days: "00",
  });

  const updateTimeDifference = (inputTime: Date) => {
    let now = new Date().getTime();
    if (!inputTime) {
      setDate({
        seconds: "00",
        minutes: "00",
        hours: "00",
        days: "00",
      });
    } else {
      let timeleft = inputTime.getTime() - now;
      if (timeleft <= 0) {
        setDate({
          seconds: "00",
          minutes: "00",
          hours: "00",
          days: "00",
        });
      } else {
        setDate({
          seconds: ("0" + Math.floor((timeleft % (1000 * 60)) / 1000)).slice(
            -2
          ),
          minutes: (
            "0" + Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60))
          ).slice(-2),
          hours: (
            "0" +
            Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          ).slice(-2),
          days: ("0" + Math.floor(timeleft / (1000 * 60 * 60 * 24))).slice(-2),
        });
      }
    }
  };

  useEffect(() => {
    if (!countDownDate) {
      return;
    }
    updateTimeDifference(countDownDate);
    const interval = setInterval(() => {
      updateTimeDifference(countDownDate);
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownDate]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Grid container spacing={0}>
            <Grid item xs={3}>
              <Paper className={classes.paper} elevation={0}>
                {date.days}
                <div className={classes.dot}>:</div>
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Days
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper} elevation={0}>
                {date.hours}
                <div className={classes.dot}>:</div>
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Hours
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper} elevation={0}>
                {date.minutes}
                <div className={classes.dot}>:</div>
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Minutes
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper} elevation={0}>
                {date.seconds}
              </Paper>
              <Paper
                className={classNames(classes.paper, classes.paperTime)}
                elevation={0}
              >
                Seconds
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
